import { render, staticRenderFns } from "./ResLoading.vue?vue&type=template&id=f2afa7b8"
import script from "./ResLoading.vue?vue&type=script&lang=js"
export * from "./ResLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports